import type { SxProps, Theme } from '@mui/material';

/** Tabla de "Buscar pendientes": encabezados compactos para que entre sin scroll horizontal. */
export const pendientesTableSx: SxProps<Theme> = {
  '& .MuiTableCell-root': { px: 1 },
  '& .MuiTableCell-head': { fontWeight: 600, lineHeight: 1.2, verticalAlign: 'bottom' },
};

/** Columna de acciones fija a la derecha, visible aunque la tabla tenga scroll horizontal. */
export const pendientesAccionCellSx: SxProps<Theme> = {
  position: 'sticky',
  right: 0,
  zIndex: 1,
  bgcolor: 'background.paper',
  whiteSpace: 'nowrap',
  boxShadow: '-6px 0 6px -6px rgba(0,0,0,0.25)',
};

export const pendientesArticuloCellSx: SxProps<Theme> = {
  minWidth: 180,
  wordBreak: 'break-word',
};
